<template>
  <div class="modal fade" id="measurement-tool-hint-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-5">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h3><strong>Quick Measurement tool</strong></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>Measure a point to point section of the trail and calculate its distance, elevation and estimated duration</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <img src="../../images/measurement_tool_hint.png" class="d-block img-fluid my-3">
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>While the measurement tool is active, click on the map line to set a start point, and then again at another point to set your measurement. </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-primary btn-block" data-bs-dismiss="modal">Continue</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
});

</script>
